import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Checkbox,
  FormControlLabel,
  Typography,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import useDrawerAccordionBaseStyles from "./styles/useDrawerAccordionBaseStyles";
import useDisplaySettingsAccordionStyles from "./styles/useDisplaySettingsAccordionStyles";
import { getIconComponent } from "../../../icons/iconRegistry";
import {
  useLanguage,
  localizedField,
  t,
} from "../../../contexts/LanguageContext";

/**
 * 表示設定アコーディオン。
 * campus_config.json の displaySettings 配列から動的にチェックボックスを生成する。
 *
 * @param {Array}    displaySettings - { id, label, icon } の配列
 * @param {Object}   checkedState    - { [id]: boolean } の表示状態
 * @param {Function} onCheckedChange - (id, checked) => void
 */
function DisplaySettingsAccordion({
  displaySettings,
  checkedState,
  onCheckedChange,
}) {
  const baseClasses = useDrawerAccordionBaseStyles();
  const displayClasses = useDisplaySettingsAccordionStyles();
  const classes = { ...baseClasses, ...displayClasses };
  const { language } = useLanguage();

  if (!displaySettings || displaySettings.length === 0) return null;

  return (
    <Accordion defaultExpanded className={classes.accordion}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        className={classes.accordionSummary}
      >
        <Typography className={classes.accordionSummaryText}>
          {t("displaySettings", language)}
        </Typography>
      </AccordionSummary>
      <AccordionDetails className={classes.accordionDetails}>
        {displaySettings.map((setting) => {
          const IconComponent = getIconComponent(setting.icon);
          return (
            <FormControlLabel
              key={setting.id}
              className={classes.formControlLabel}
              control={
                <Checkbox
                  checked={!!checkedState[setting.id]}
                  onChange={(e) =>
                    onCheckedChange(setting.id, e.target.checked)
                  }
                  color="primary"
                />
              }
              label={
                <div style={{ display: "flex", alignItems: "center" }}>
                  {localizedField(setting, "label", language)}
                  {IconComponent && <IconComponent style={{ marginLeft: 8 }} />}
                </div>
              }
            />
          );
        })}
      </AccordionDetails>
    </Accordion>
  );
}

export default React.memo(DisplaySettingsAccordion);
